import React from 'react';
import { Field } from 'react-final-form';

import RadioButtonInput from '../utils/RadioButtonInput';

const RadioButtonField = React.memo( ( {
  field, validate, value, name, ...rest
} ) => {
  if ( field ) {
    return (
      <Field name={field} validate={validate}>
        {( { meta, input } ) => {
          const isInvalid = ( meta.touched && meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && meta.submitError );

          return (
            <RadioButtonInput
              {...input}
              {...rest}
              value={input.value || ''}
              inputOnChange={input.onChange}
              inputName={input.name}
              focused={meta.active}
              meta={meta}
              isInvalid={isInvalid}
            />
          );
        }}
      </Field>
    );
  }
  return (
    <RadioButtonInput
      {...rest}
      value={value || ''}
      inputName={name}
    />
  );
} );

export default RadioButtonField;
